import type { FeatureModule } from '@store/features/types';
import storage from 'redux-persist/lib/storage';

import placementReducer from './placementSlice';

export const jotSupportFeature: FeatureModule = {
  id: 'jotSupport',
  name: 'Jot support',
  reducers: { jotSupport: placementReducer },
  middleware: [],
  persistence: {
    enabled: true,
    key: 'jotSupport',
    storage,
    whitelist: ['placement'],
    version: 1,
  },
  sync: { enabled: false },
};
